import CenterLoading from 'components/center-loading'
import { SelectBox } from 'components/uikit-adapter/index'
import { useEffect, useState } from "react";
import intl from 'react-intl-universal'
import Fetch from "utils/fetch";
import "./budget-form.css";
import Button from 'components/button'
import GenericModal from "components/generic-modal";
import Input from "components/input";
import { IMaterialGroupForm } from 'types/material-group/material-group-response'
import { formatErrorMessage } from "utils/handle-error";
import { usesTmsIntegration } from 'utils/validations-general-settings'

export interface BudgetFormProps {
  editMode: boolean;
  handleClose: () => void;
  handleFeedback: (message?: string) => void;
  handleRefresh: () => void;
  idEdit?: number;
  open: boolean;
  profileAdminOrMasterData: boolean;
};

const BudgetForm = ({ editMode, handleClose, handleFeedback, handleRefresh, idEdit, open, profileAdminOrMasterData }: BudgetFormProps) => {
  const [budget, setBudget] = useState<IMaterialGroupForm>({});
  const [internationalMaterialGroups, setInternationalMaterialGroups] = useState([]);
  const [materialGroupTypes, setMaterialGroupTypes] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const showTmsIntegrationFields = usesTmsIntegration();

  useEffect(() => {
    loadInternationalMaterialGroups();
    loadMaterialGroupTypes();

    if (editMode) searchBudgetById();
  }, []);

  const loadInternationalMaterialGroups = () => {
    Fetch.get(`/international-material-groups`)
      .then((response) => {
        setInternationalMaterialGroups(response.data);
      });
  }

  const loadMaterialGroupTypes = () => {
    Fetch.get(`/material-groups:material-groups-types`)
      .then((response) => { setMaterialGroupTypes(response.data); });
  }

  const startSaving = () => {
    setIsSaving(true);
  }

  const stopSaving = () => {
    setIsSaving(false);
  }

  const proccessErro = (exception: any) => {
    handleFeedback(formatErrorMessage(exception))
  }

  const searchBudgetById = () => {
    const idFamily = idEdit;

    Fetch.get(`/material-groups/${idFamily}`)
      .then((response) => proccessData(response.data))
      .catch((e) => proccessErro(e))
  }

  const changeValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const prop = event.target.name
    const value = event.target.value

    setBudget(prevState => ({
      ...prevState,
      [prop]: value
    }))
  }

  const updateInternationalMaterialGroupSelectValue = (prop: string, value: any) => {
    setBudget(prevState => ({
      ...prevState,
      InternationalMaterialGroup: {
        ...prevState.InternationalMaterialGroup,
        [prop]: value
      }
    }))
  }

  const updateSelectValue = (prop: string, value: any) => {
    setBudget(prevState => ({
      ...prevState,
      [prop]: value
    }))
  }

  const proccessData = (data: any) => {
    const { Id, Description, InternationalMaterialGroupId, InternationalMaterialGroupName, IsBottle, IsCan, Lines, MaterialGroupType, CommodityCode, CustomerCode } = data

    setBudget({
      Id: Id,
      Description: Description,
      IsBottle: IsBottle,
      IsCan: IsCan,
      Lines: Lines,
      MaterialGroupType: MaterialGroupType,
      InternationalMaterialGroup: {
        Id: InternationalMaterialGroupId,
        Name: InternationalMaterialGroupName
      },
      CommodityCode: CommodityCode,
      CustomerCode: CustomerCode
    })
  }

  const save = () => {
    startSaving()

    let model = {
      Id: budget.Id,
      Description: budget.Description,
      IsBottle: budget.IsBottle,
      IsCan: budget.IsCan,
      MaterialGroupType: budget.MaterialGroupType,
      InternationalMaterialGroupId: budget.InternationalMaterialGroup?.Id,
      InternationalMaterialGroupName: budget.InternationalMaterialGroup?.Name,
      Lines: budget.Lines,
      CommodityCode: showTmsIntegrationFields ? (budget.CommodityCode ?? null) : undefined,
      CustomerCode: showTmsIntegrationFields ? (budget.CustomerCode ?? null) : undefined
    }

    model.Id = editMode ? idEdit : undefined;
    Fetch.post(`/material-groups`, model)
      .then(handleRefresh)
      .then(() => handleFeedback(`${intl.get('feedbacks.register')} ${!editMode ? intl.get('feedbacks.saved') : intl.get('feedbacks.updated')} ${intl.get('feedbacks.withSuccess')}`))
      .catch((e) => proccessErro(e))
      .finally(stopSaving)
  }

  return (
    <div>
      <GenericModal
        open={open}
        // A unica forma de fechar o modal deve ser no botão de fechar.
        onRequestClose={() => {}}
        modalStyle={{ width: "600px" }}
      >
        <CenterLoading isLoading={isSaving} fullHeightParent />
        <h3 className="modal-title">
          {editMode
            ? intl.get("master-data.walletsAndFamilys.wallets.actions.editWallet")
            : intl.get("master-data.walletsAndFamilys.wallets.actions.newWallet")}
        </h3>
        <div className="line-1-columns">
          <Input
            required
            name="Description"
            onChange={changeValue}
            value={budget.Description}
            label={intl.get("master-data.general-configuration.name")}
            disabled={!profileAdminOrMasterData}
          />
        </div>
        <div className="line-1-columns">
          <SelectBox
            name="InternationalMaterialGroup"
            label={intl.get("master-data.walletsAndFamilys.wallets.InternationalMaterialGroupName")}
            valueKey="Id"
            labelKey="Name"
            value={budget.InternationalMaterialGroup?.Id}
            options={internationalMaterialGroups}
            onChange={(value: { Id: any }) =>
              updateInternationalMaterialGroupSelectValue("Id", value?.Id)
            }
            disabled={!profileAdminOrMasterData}
            searchable
            clearable
            placeholder={undefined}
          />
        </div>
        <div className="line-1-columns">
          <SelectBox
            name="MaterialGroupType"
            className="materialGroupType"
            label={intl.get("master-data.walletsAndFamilys.wallets.MaterialGroupType")}
            valueKey="Id"
            labelKey="Name"
            value={budget.MaterialGroupType}
            options={materialGroupTypes}
            onChange={(value: { Id: any }) => updateSelectValue("MaterialGroupType", value?.Id)}
            disabled={!profileAdminOrMasterData}
            searchable
            placeholder={undefined}
          />
        </div>
        {showTmsIntegrationFields && (
          <>
            <div className="line-1-columns">
              <Input
                name="CommodityCode"
                onChange={changeValue}
                value={budget.CommodityCode ?? ""}
                label={intl.get("master-data.walletsAndFamilys.wallets.CommodityCode")}
                disabled={!profileAdminOrMasterData}
                maxLength={20}
              />
            </div>
            <div className="line-1-columns">
              <Input
                name="CustomerCode"
                onChange={changeValue}
                value={budget.CustomerCode ?? ""}
                label={intl.get("master-data.walletsAndFamilys.wallets.CustomerCode")}
                disabled={!profileAdminOrMasterData}
                maxLength={20}
              />
            </div>
          </>
        )}
        <div className="footer-dialog-buttons">
          <Button
            value={intl.get("geral.buttonsDefault.cancel")}
            buttonType="default"
            onClick={() => {
              handleClose();
            }}
            className="button"
            style={{ margin: "0px", marginTop: "24px" }}
          />
          {profileAdminOrMasterData && (
            <Button
              value={intl.get("geral.buttonsDefault.save")}
              buttonType="primary"
              className="button"
              onClick={save}
              style={{ margin: "0px", marginTop: "24px" }}
            />
          )}
        </div>
      </GenericModal>
    </div>
  );
}

export default BudgetForm;
